import { atom } from 'recoil';

export const isLoadingState = atom({
  key: 'isLoadingState', // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});